<template>
    <div class="card-header">
        <span class="refer" @click="backToPatientList">{{ $t('modals.header_layout.back.title') }}</span>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
            }
        },
        methods: {
            backToPatientList() {
                this.$router.push(`/patients/list/patients`)
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/patients/_patient';
</style>
